/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthenticationPasswordRequest
 */
export interface AuthenticationPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationPasswordRequest
     */
    token: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationPasswordRequest
     */
    userId: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationPasswordRequest
     */
    newPassword: string | null;
}

export function AuthenticationPasswordRequestFromJSON(json: any): AuthenticationPasswordRequest {
    return AuthenticationPasswordRequestFromJSONTyped(json, false);
}

export function AuthenticationPasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthenticationPasswordRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
        'userId': json['userId'],
        'newPassword': json['newPassword'],
    };
}

export function AuthenticationPasswordRequestToJSON(value?: AuthenticationPasswordRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'userId': value.userId,
        'newPassword': value.newPassword,
    };
}

